import type { BlockCardsImage } from 'types/block-cards-image';
import React from 'react';
import { Wrap, Badge, Paragraph, Button } from '@leafwell/components';
import HeadingBody from './heading-body';
import Figure from './figure';
import WysiwygContent from './wysiwyg-content';

const CardsImage: React.FC<BlockCardsImage> = ({
  sectionId,
  title,
  label,
  description,
  button,
  cards,
}) => {
  return (
    <Wrap id={sectionId}>
      <div className="text-center">
        {title?.length > 0 && (
          <HeadingBody className="!mb-2" {...{ level: '2', title }} />
        )}
        {label?.length > 0 ? <p>{label}</p> : null}
      </div>
      {cards?.length > 0 ? (
        <ol className="grid sm:grid-cols-2 xl:grid-cols-4 gap-x-4 gap-y-2">
          {cards?.map(({ title, description, image }, idx) => {
            return (
              <li
                key={`${sectionId}-${idx}`}
                className="border border-gray-200 rounded-md bg-[#FFFAF8] flex flex-col gap-y-2 p-4"
              >
                <Badge
                  className="w-fit col-span-full"
                  label={`Step ${idx + 1}`}
                  variant="white"
                  size="xsmall"
                />
                {image && (
                  <Figure
                    {...image}
                    className="grid items-end justify-center -mx-4 max-w-80 lg:max-w-none"
                  />
                )}
                <div className="flex flex-col gap-y-2">
                  {title?.length > 0 && (
                    <HeadingBody
                      tagName="p"
                      level="5"
                      title={title}
                      className="font-medium text-center"
                    />
                  )}
                  {description?.length > 0 && (
                    <Paragraph
                      size="small"
                      tagName="div"
                      className="text-center"
                      dangerouslySetInnerHTML={{ __html: description }}
                    />
                  )}
                </div>
              </li>
            );
          })}
        </ol>
      ) : null}
      {description?.length > 0 ? (
        <div className="mt-10 grid gap-y-6 justify-items-center">
          <WysiwygContent
            content={description}
            largerParagraph={false}
            className="max-w-96"
          />
          {button && (
            <Button
              href={button.url}
              label={button.title}
              rounded={true}
              variant="secondary"
              filled={false}
              target={button.target}
              className="w-fit h-fit"
            />
          )}
        </div>
      ) : null}
    </Wrap>
  );
};

export default CardsImage;
